import { Grid as MaterialGrid, Typography } from '@material-ui/core';
import { State } from '@progress/kendo-data-query';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import React, { useEffect, useState } from 'react';
import { CheckboxColumnMenu, SimpleColumnMenu } from '../../../../libs/grid';
import useStylesGrid from '../../../../styles/grid.styles';
import LoadingPanel from '../../../../ui/old/Feedback/LoadingPanel';
import useStyles from '../../styles/useStyles';
import ImageStatus from '../ImageStatus';
import useAsiteSyncLogsGrid from './useAsiteSyncLogsGrid';

interface AsiteSyncLogsGridProps {
    gridState: State,
    setGridState: React.Dispatch<React.SetStateAction<State>>
}

const AsiteSyncLogsGrid: React.FC<AsiteSyncLogsGridProps>  = ({gridState, setGridState}) => {
    const classesGrid = useStylesGrid();
    const classes = useStyles();
    const {
        AsiteSyncLogsQuery: { isLoading, isSuccess },
        gridResult,
        handleDataStateChange,
    } = useAsiteSyncLogsGrid(gridState, setGridState);

    const [gridData, setGridData] = useState(gridResult);

    useEffect(() => {
        setGridData(gridResult);
    }, [gridResult]);

    return (
        <>
            {isSuccess && (
                <Grid
                    className={classesGrid.grid + ' ' + classes.gridHeight}
                    pageable={{
                        buttonCount: 5,
                        type: 'numeric',
                        pageSizes: [5, 10, 20, 50],
                    }}
                    {...gridState}
                    {...gridData}
                    sortable={true}
                    onDataStateChange={handleDataStateChange}
                >
                    <GridToolbar>
                        <MaterialGrid container style={{ minHeight: '30px' }}>
                            <Typography variant="h6" style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                                Logs
                            </Typography>
                        </MaterialGrid>
                    </GridToolbar>
                    <GridColumn
                        field="startDate"
                        title="Start Date"
                        format="{0:dd/MM/yyyy HH:mm:ss}"
                        filterable={false}
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        width={'200'}
                    />
                    <GridColumn
                        field="endDate"
                        title="End Date"
                        format="{0:dd/MM/yyyy HH:mm:ss}"
                        filterable={false}
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        width={'200'}
                    />
                    <GridColumn
                        field="status"
                        title="Status"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        columnMenu={(props: any) => (
                            <div className={'alignRight'}>
                                <CheckboxColumnMenu {...props} asiteLogs={true} data={gridData?.data} />
                            </div>
                        )}
                        width={'90'}
                        cell={(props: any) => <ImageStatus {...props} />}
                    />
                    <GridColumn
                        field="message"
                        title="Message"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        columnMenu={(props: any) => <SimpleColumnMenu {...props} />}
                        width={'auto'}
                    />
                    <GridColumn
                        field="emailSend"
                        title="Notified People"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        columnMenu={(props: any) => (
                            <div className={'alignRight'}>
                                <CheckboxColumnMenu {...props} data={gridData?.data} />
                            </div>
                        )}
                        width={'150'}
                    />
                </Grid>
            )}
            {isLoading && <LoadingPanel />}
        </>
    );
};

export default AsiteSyncLogsGrid;
